import { FC } from "react"
import { css } from "@emotion/react"
import { Box, Button, ButtonProps, Heading, HeadingProps } from "@ncs/web-legos"
import { PartPreviewCardEcomm } from ".."
import { useOnliePartsEcommService } from "@ncs/ncs-api/portal-apps"
import { Skeleton } from "@material-ui/lab"
import { carousel } from "./styles"

interface PartPreviewRowProps {
	heading?: string
	partIds: (string | null | undefined)[]
	button?: ButtonProps
	headingVariant?: HeadingProps["variant"]
	ordering?: string
	onAddToCart?: (part: any) => void
}

export const PartPreviewRowEcomm: FC<PartPreviewRowProps> = ({
	heading,
	partIds,
	button,
	headingVariant = "h2",
	ordering = "title",
	onAddToCart,
}) => {
	const partIdsToShow: string[] = [
		...new Set(partIds?.filter((id) => id).map((id) => String(id))),
	]

	const [customerParts, isLoadingCustomerParts] = useOnliePartsEcommService({
		params: {
			onlinePartIds: partIdsToShow,
			ordering,
		},
		queryConfig: {
			enabled: partIdsToShow.length > 0,
		},
		pageSize: 10,
	})

	if (partIdsToShow.length === 0) {
		return null
	}

	return (
		<>
			{heading && (
				<Heading variant={headingVariant} bold mt={1} mb={1.5}>
					{heading}
				</Heading>
			)}

			<Box d="flex" css={carousel}>
				{isLoadingCustomerParts ?
					Array.from({ length: 5 }).map((_, index) => (
						<Box display="flex" flexDirection="column" key={index}>
							<Skeleton variant="rect" height={200} width={220} />
							<Box mt={3}>
								<Skeleton variant="text" height={44} width={220} />
							</Box>
							<Box>
								<Skeleton variant="text" height={22} width={120} />
							</Box>
							<Box mt={3}>
								<Skeleton variant="text" height={42} width={120} />
							</Box>
							<Box mt={3}>
								<Skeleton variant="text" height={"52px"} width={220} />
							</Box>
						</Box>
					))
				:	customerParts?.map((part: any) => (
						<Box
							key={part.id}
							css={css`
								flex-shrink: 0;
							`}
						>
							<PartPreviewCardEcomm part={part} onAddToCart={onAddToCart} />
						</Box>
					))
				}
			</Box>

			{button && (
				<Box mt={2}>
					<Button {...button} />
				</Box>
			)}
		</>
	)
}
